import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  constructor(private firestore: AngularFirestore) {}

  public createClient(client){
    delete client.id;
    return this.firestore.collection('clients').add({...client});
  }

  public getClient(documentId: string) {
    return this.firestore.collection('clients').doc(documentId).snapshotChanges();
  }

  public getClients() {
    return this.firestore.collection('clients').snapshotChanges();
  }

  public getClientsByBirthday(birthday: string){
    return this.firestore.collection('clients', ref=> ref.orderBy('birthday.day').where('birthday.month', '==', birthday)).snapshotChanges()
  }

  public updateClient(client){
    const id = client.id;
    delete client.id;
    return this.firestore.doc('clients/'+id).update({...client});
  }

  public deleteClient(id){
    return this.firestore.collection('clients').doc(id).delete();
  }

}
